import { useSelector } from "react-redux";

/**
 * Custom hook to retrieve prescription display settings
 * Falls back to showing everything when no saved prescription settings exist
 */
const usePrescriptionSettings = () => {
  const auth = useSelector((state) => state?.auth);

  const prescriptionSettings =
    auth?.prescriptionSettings ||
    auth?.user?.settings?.prescription_settings ||
    auth?.user?.settings?.invoice_size?.prescription_settings ||
    {};

  return {
    prescriptionSettings: {
      items: prescriptionSettings.items ?? true,
      diagnosis: prescriptionSettings.diagnosis ?? true,
      vital_signs: prescriptionSettings.vital_signs ?? true,
    },
  };
};

export default usePrescriptionSettings;
